<template>
    <div>
        <div class="row">
            <a href="/club/events">Back to Club Events</a>
        </div>
        <div class="row h1 page-header">
            Event&nbsp;Volunteers
            <span class="pull-right">
            <a :href="`/club/events/${eventId}/jobs`" class="btn btn-success">Jobs</a>
            <a :href="`/club/events/${eventId}/volunteers/download`" class="btn btn-primary">Download</a>
            <a :href="`/club/events/${eventId}/send_email`" class="btn btn-primary">Email Volunteers&nbsp;<span class="glyphicon glyphicon-envelope" aria-hidden="true"></span></a>
            <button class="btn btn-primary" @click="sendEventJobReminders">Send Reminders</button>
            </span>
        </div>

        <v-event-info :event-id="eventId"></v-event-info>

        <v-event-volunteers-list :event-id="eventId" ref="eventsList" @event-edit="editJob($event)"></v-event-volunteers-list>
    </div>
</template>

<script>
    export default {
        props: [
            'eventId'
        ],

        data() {
            return {
                addMode: false,
                currentJob: null,
                event: null
            }
        },

        mounted() {
            this.getEvent();
        },

        methods: {
            showNewJobForm() {
                this.addMode = true;
            },

            hideNewJobForm() {
                this.addMode = false;
            },

            sendEventJobReminders() {
                axios.post(`/api/v1/club_events/${this.eventId}/reminders`)
                    .then(response => {
                        this.$message({ message: response.data, type:'success'});
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem sending job reminders.', type: 'error'});
                    });

            },

            reloadJobs() {

            },

            getEvent() {
                axios.get(`/api/v1/club_events/${this.eventId}`)
                    .then(response => {
                        this.event = response.data;
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem fetching the event.', type: 'error'});
                    });
            }
        }
    }
</script>
